/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clean_Real_Mallard_KissInputs */

const fr_clean_real_mallard_kiss = /** @type {(inputs: Clean_Real_Mallard_KissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez les permissions spécifiques pour cet utilisateur.`)
};

/**

* @param {Clean_Real_Mallard_KissInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const clean_real_mallard_kiss = /** @type {((inputs?: Clean_Real_Mallard_KissInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clean_Real_Mallard_KissInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_clean_real_mallard_kiss(inputs)
});